<template>
    <ReportWrapper>
      <template #actions>
        <v-spacer />
  
        <v-btn
          color="primary"
          :loading="isLoading"
          @click="download"
        >
          <v-icon size="1rem" class="mr-1">mdi-tray-arrow-down</v-icon>
          <span>Download</span>
        </v-btn>
      </template>
    </ReportWrapper>
  </template>
  
  <script lang="ts">
  import { defineAsyncComponent, defineComponent, ref } from 'vue';
  import { useReports } from '@/composables/reports/useReports';
  import { downloadFile } from '@/helpers/download';
  import { useToast } from '@/composables/useToast';
  import ReportWrapper from '@/components/reports/ReportWrapper.vue';
  import { AxiosError } from 'axios';
  
  export default defineComponent({
    name: 'ReleasedToGOReport',
    components: {
      ReportWrapper,
      CustomerAutocomplete: defineAsyncComponent(
        () => import('@/components/autocomplete/CustomerAutocompleteComponent.vue')
      ),
    },
    setup() {
      const toast = useToast();
    
      const { useDownloadReleasedToGoReport } = useReports();
      const { mutateAsync: downloadReport, isLoading } = useDownloadReleasedToGoReport();
  
      const download = async () => {
        try {
          const data = await downloadReport();
  
          if (!data) return;
  
          downloadFile(data.base64Data, data.filename ?? 'Released to General Order Report');
        } catch (error) {
          const axiosError = error as AxiosError<string>;
          toast.error(axiosError?.response?.data!);
        }
      };
  
      return { isLoading, download };
    },
  });
  </script>
  